// src/components/Input.js
import React from "react";

function Input({
  type = "text",
  placeholder = "",
  value,
  onChange,
  className,
  id,
  borderColor,
  autoComplete = "on",
}) {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      id={id}
      //   style={{
      //     border: "1px solid transparent", // Set border to transparent so gradient can show
      //     borderImageSource:
      //       "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)",
      //     borderImageSlice: 1, // Ensure the gradient covers the full border
      //   }}
      className={`leap-min-h-[56px] leap-bg-[#2e3351]  !leap-rounded-[16px] leap-px-4 leap-text-lg  ${className}`}
      autoComplete={autoComplete}
    />
  );
}

export default Input;
// border: ;

// border-image-source: linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%);
